import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Layout } from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import CaraBeliPage from "@/pages/CaraBeliPage";
import BantuanPage from "@/pages/BantuanPage";
import TentangPage from "@/pages/TentangPage";
import KetentuanPage from "@/pages/KetentuanPage";
import PrivasiPage from "@/pages/PrivasiPage";
import GaransiPage from "@/pages/GaransiPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminPage, { AdminResetPage } from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/reset" element={<AdminResetPage />} />
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              {/* Catalog is a route-driven dialog rendered by the Layout over
                  the storefront. /produk and /produk/:slug open it. */}
              <Route path="/produk" element={<HomePage />} />
              <Route path="/produk/:slug" element={<HomePage />} />
              <Route path="/cara-beli" element={<CaraBeliPage />} />
              <Route path="/bantuan" element={<BantuanPage />} />
              <Route path="/tentang" element={<TentangPage />} />
              <Route path="/ketentuan" element={<KetentuanPage />} />
              <Route path="/privasi" element={<PrivasiPage />} />
              <Route path="/garansi" element={<GaransiPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
      </ErrorBoundary>
    </div>
  );
}

export default App;
